export default __webpack_public_path__ + "fb468efee6e31d29393d824b895be59d.svg";